import React from 'react';
import moment from 'moment';

const footerStyles = `
@keyframes footer-fade-in {
  from { opacity: 0; transform: translateY(6px); }
  to   { opacity: 1; transform: translateY(0); }
}
.cp-footer {
  text-align: center;
  margin: 24px 0 32px;
  animation: footer-fade-in 0.5s ease both;
}
.cp-footer-bar {
  height: 2px;
  background: linear-gradient(90deg, transparent, #1890ff55, transparent);
  margin: 0 auto 14px;
  width: 60%;
  max-width: 300px;
  border-radius: 2px;
}
.cp-footer-name {
  font-size: 12px;
  font-weight: 600;
  color: #8c8c8c;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  margin: 0 0 3px;
}
.cp-footer-copy {
  font-size: 11px;
  color: #bfbfbf;
  letter-spacing: 0.5px;
}
`;

function Footer() {
  return (
    <>
      <style>{footerStyles}</style>
      <div className="cp-footer">
        <div className="cp-footer-bar" />
        <p className="cp-footer-name">
          {process.env.REACT_APP_PROJECT_NAME || 'No Env Project name'}{' '}
          <span style={{ color: '#1890ff', fontWeight: 700 }}>
            {process.env.REACT_APP_VERSION || '1.0.0'}
          </span>
        </p>
        <small className="cp-footer-copy">
          &copy; {moment().format('YYYY')} · All rights reserved
        </small>
      </div>
    </>
  );
}

export default Footer;